export default __webpack_public_path__ + "img/br.5ec13287.svg";